module.exports = __webpack_public_path__ + "static/img/ftworkforce.8e952f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ftworkforce.png
// module id = TSHV
// module chunks = 0